// extracted by mini-css-extract-plugin
export default {"body":"HomeLayout_body__Qsqoi","top":"HomeLayout_top__jq19t","center":"HomeLayout_center__tm-Mh","bottom":"HomeLayout_bottom__iNpdu","right":"HomeLayout_right__rlNoB"};